import axios from 'axios';

// Runtime config is delivered by public/config.js — a plain <script> in
// index.html, separate from the bundle. Read it PER REQUEST rather than caching
// it at module-load: if the bundle ever evaluates before that script has run,
// a cached value would stay undefined for the whole session and every request
// would go out without x-db-name, which the API rejects with 400.
const runtimeConfig = () => window.MANTLE_CONFIG || {};
const API_FALLBACK = 'http://localhost:5000/api';

const api = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const { API_URL, TENANT_DB } = runtimeConfig();
    const jwt = localStorage.getItem('jwt');
    const roleUrid = localStorage.getItem('roleUrid');
    const siteCode = localStorage.getItem('siteCode');
    const budgetVersionId = localStorage.getItem('budgetVersionId');

    config.baseURL = API_URL || API_FALLBACK;

    if (jwt) {
      config.headers['Authorization'] = `Bearer ${jwt}`;
    }

    // Injecting the strictly configured database name
    if (TENANT_DB) {
      config.headers['x-db-name'] = TENANT_DB;
    } else {
      // Without this every API call 400s — loud, because the symptom downstream
      // is just "no data" and is otherwise very hard to trace.
      console.error(
        '[api] window.MANTLE_CONFIG.TENANT_DB is not set — public/config.js did not load. ' +
        'All API requests will fail with "Missing x-db-name header".'
      );
    }

    if (roleUrid) {
      config.headers['x-role-urid'] = roleUrid;
    }
    if (siteCode) {
      config.headers['x-site-code'] = siteCode;
    }
    if (budgetVersionId) {
      config.headers['x-budget-version-id'] = budgetVersionId;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('jwt');
      localStorage.removeItem('uid');
      localStorage.removeItem('uname');
      localStorage.removeItem('assignments');
      localStorage.removeItem('roleUrid');
      localStorage.removeItem('siteCode');
      localStorage.removeItem('budgetVersionId');

      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;